// extracted by mini-css-extract-plugin
module.exports = {"categories":"_c20efe70","category":"_1c5b1a53","section":"_612bf15d","card_heading":"_fca18ce4"};